import React, { type ReactNode } from 'react';
import { AssociatedIssuesContainer } from '@atlassian/jira-portfolio-3-associated-issues';
import type { IssueId } from '@atlassian/jira-shared-types';
import { useCloudId } from '@atlassian/jira-tenant-context-controller';

const Wrapper = ({
	associatedIssueIds,
	children,
}: {
	associatedIssueIds: IssueId[];
	children: ReactNode;
}) => {
	const cloudId = useCloudId();
	return (
		<AssociatedIssuesContainer associatedIssueIds={associatedIssueIds} cloudId={cloudId}>
			{children}
		</AssociatedIssuesContainer>
	);
};

export default Wrapper;
